<template>
  <v-layout>
    <v-flex>
      <v-layout wrap align-center>
        <h1 class="headline">Star Ratings</h1>
        <v-spacer></v-spacer>
        <v-flex xs12 sm4 class="pb-2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Quick Filter..."
            single-line
            hide-details
            v-model="search"
            class="ma-0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              fab
              dark
              color="primary"
              @click="createItem"
              class="ma-2"
            >
              <v-icon dark>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Create New Star Rating</span>
        </v-tooltip>
      </v-layout>
      <v-card>
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          v-bind="pagingOptions"
          :search="search"
          item-key="node.id"
          fixed-header
          hide-default-footer
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              :hide-view="true"
              @deleteItem="deleteItem($event)"
              @editItem="editItem($event)"
            ></default-list-actions>
          </template>
          <template v-slot:item.notInUse="{ item }">
            <v-simple-checkbox
              v-model="item.node.notInUse"
              disabled
            ></v-simple-checkbox>
          </template>
        </v-data-table>
      </v-card>
      <v-card>
        <v-dialog v-model="starEditorDialog" persistent width="500">
          <v-card>
            <star-editor
              :star="selectedStar"
              :doSaveStar="doSaveStar"
              :starEditorDialog="starEditorDialog"
              @saved="onSaved($event)"
              @onResetSave="onResetSave"
            ></star-editor>
            <v-card-actions class="grey lighten-4">
              <v-spacer></v-spacer>
              <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
              <v-btn color="primary" @click="onSaveStar">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  ALL_STARS_SEARCH_QUERY,
  STAR_DELETE_MUTATION,
} from "../../../../constants/graphql";
import StarEditor from "./StarEditor";
import DefaultListActions from "../../shared/DefaultListActions";
import { pagingOptions } from "../../../../helpers/index";
import SimpleListMixin from "../../../../mixins/SimpleListMixin";
export default {
  name: "StarsList",
  mixins: [SimpleListMixin],
  components: {
    DefaultListActions,
    StarEditor,
  },

  data() {
    return {
      pagingOptions,
      search: "",
      selectedStar: {},
      stars: {},
      starEditorDialog: false,
      doSaveStar: false,
      headers: [
        {
          text: "Name",
          align: "left",
          value: "node.name",
          name: "name",
        },
        {
          text: "Number",
          align: "left",
          value: "node.number",
          name: "name",
        },
        {
          text: "Not In Use",
          align: "left",
          value: "notInUse",
          name: "notInUse",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          name: "actions",
          align: "center",
        },
      ],
    };
  },

  computed: {
    items() {
      return this.stars ? this.stars.edges : [];
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  methods: {
    createItem() {
      this.selectedStar = {};
      this.starEditorDialog = true;
    },
    editItem(item) {
      this.selectedStar = item.node;
      this.starEditorDialog = true;
    },
    deleteItem(item) {
      this.$apollo
        .mutate({
          mutation: STAR_DELETE_MUTATION,
          variables: {
            starId: item.node.id,
          },
        })
        .then(this.removeGqlObjectHandler, this.removeGqlObjectErrorHandler);
    },
    removeGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: "Star rating removed.",
      });
      if (this.$apollo.queries.stars != null) {
        this.$apollo.queries.stars.refetch();
      }
    },
    removeGqlObjectErrorHandler(err) {
      this.$store.dispatch("showAppSnackbar", {
        msg: err.graphQLErrors[0].message,
        color: "error",
      });
    },
    onSaved(context) {
      if (this.$apollo.queries.stars != null) {
        this.$apollo.queries.stars.refetch();
      }
      this.onResetSave();
      this.starEditorDialog = false;
      this.selectedStar = {};
      let msg =
        context == "edit" ? "Star rating updated." : "Star rating created.";
      this.$store.dispatch("showAppSnackbar", { msg });
    },
    onResetSave() {
      this.doSaveStar = false;
    },
    closeDialog() {
      this.starEditorDialog = false;
      this.selectedStar = {};
    },
    onSaveStar() {
      this.doSaveStar = true;
    },
  },

  apollo: {
    stars: {
      query: ALL_STARS_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {},
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/admin/service-types/StarsList.vue